<div class="list-container theme-checkbox">
  @for (item of items(); track $index) {
    @if (item.display) {
      @let selected = isSelected(item);
      <mat-checkbox
        #checkbox
        type="checkbox"
        (change)="handleChange($event, item)"
        [checked]="selected"
        data-testid="filter-checkbox"
      >{{item.label}}</mat-checkbox>
    }
  }
</div>
